import React from "react";

import { useTranslation } from "react-i18next";

import { Wrapper, WrapperLeftSide, InventoryButtonsContainer, InventoryButton } from "./styles";

export enum InventoryType {
  ACTUAL = "Actual",
  ESTIMATED = "Estimated",
}

interface HeaderProps {
  inventoryType: string;
  hasQuotedInventory?: boolean;
  rightSide?: React.ReactChild;
  setInventoryType?: (value: string) => void;
}

export default function Header(props: HeaderProps) {
  const { inventoryType = "", setInventoryType, rightSide, hasQuotedInventory } = props;
  const { t: translate } = useTranslation();

  const onSwitch = (type: InventoryType) => {
    if (!setInventoryType) return;
    setInventoryType(type);
  };

  return (
    <Wrapper>
      <WrapperLeftSide>
        <InventoryButtonsContainer>
          {hasQuotedInventory && (
            <InventoryButton
              selected={inventoryType === InventoryType.ESTIMATED}
              onClick={() => onSwitch(InventoryType.ESTIMATED)}
            >
              <span>{translate("asQuoted")}</span>
            </InventoryButton>
          )}
          <InventoryButton
            selected={inventoryType === InventoryType.ACTUAL}
            onClick={() => onSwitch(InventoryType.ACTUAL)}
          >
            <span>{translate("actual")}</span>
          </InventoryButton>
        </InventoryButtonsContainer>
      </WrapperLeftSide>
      {rightSide}
    </Wrapper>
  );
}
